import styled from 'styled-components';

import { Title } from '@xsolla/ui-core';
import { Plus } from '@xsolla/ui-icons';

import { Clock, Guide } from '../../ui/icons';

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  padding: 40px 32px 64px 32px;
  box-sizing: border-box;
  justify-content: space-between;
`;

export const WelcomeBlockWrapper = styled.div`
  width: 100%;
  max-width: 468px;
  height: auto;
  margin-right: 40px;
`;

export const DemoLoginWrapper = styled.div`
  width: 100%;
  height: 382px;
  max-height: 382px;
  max-width: 400px;
  background-size: contain;
  background-repeat: no-repeat;
`;

export const WelcomeDescription = styled.div`
  ${(p) => p.theme.typography.body}
  margin-bottom: 32px;
`;

export const WelcomeTitle = styled(Title)`
  margin-top: 13px;
  color: ${(p) => p.theme.colors.text};
`;

export const PlusIcon = styled(Plus)`
  margin-right: 4px;
`;

export const AnnotationWrapper = styled.div`
  margin-top: 32px;
  line-height: 24px;
`;

export const AnnotationSpan = styled.span`
  color: ${(p) => p.theme.colors.text};
`;

export const ClockIcon = styled(Clock)`
  fill: ${(p) => p.theme.colors.text};
  position: relative;
  top: 4px;
`;

export const GuideIcon = styled(Guide)`
  fill: ${(p) => p.theme.colors.brand};
  margin-right: 2px;
`;

export const GuideLink = styled.a`
  text-decoration: none;

  svg {
    fill: ${(p) => p.theme.colors.brand};
    margin-right: 2px;
  }
`;
